export const BARRIER_ICON_IMAGE_ID = 'rt-barrier-icon';

const _ICON_SIZE_PX = 32;

// Russian road sign 3.1 "Въезд запрещён": red-filled circle with a
// centred white horizontal bar. Matches driver intuition ("this road is
// blocked") better than the previous grey brick-wall motif. Thin dark
// rim lifts the red off pale basemap tiles.
const _NO_ENTRY_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="${_ICON_SIZE_PX}" height="${_ICON_SIZE_PX}" viewBox="0 0 32 32">
  <circle cx="16" cy="16" r="13.5" fill="#d4181d" stroke="#ffffff" stroke-width="2"/>
  <circle cx="16" cy="16" r="14.5" fill="none" stroke="#5a0a0d" stroke-width="0.8" stroke-opacity="0.5"/>
  <rect x="6" y="13" width="20" height="6" fill="#ffffff"/>
</svg>
`.trim();

export function buildBarrierIconDataUrl(): string {
  const encoded = encodeURIComponent(_NO_ENTRY_SVG);
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}

export function loadBarrierIconImage(): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image(_ICON_SIZE_PX, _ICON_SIZE_PX);
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('failed to load barrier icon'));
    img.src = buildBarrierIconDataUrl();
  });
}
